import { faShareSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import DynamicTable from "../../../components/Tables";
import {
  createProductCategory,
  getProductCategory,
  toggleCategoryStatus,
} from "../../../services/apis";

const cols = (navigate, categoryActivate) => {
  return [
    {
      id: "category",
      title: "Category Name",
      key: "category",
      isSortable: true,
      iskey: true,
      render: (value) => value,
    },
    {
      id: "productcount",
      title: "Product Count",
      key: "productcount",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "createdon",
      title: "Created on",
      key: "createdon",
      iskey: true,
      isSortable: true,
      render: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      title: "Action",
      key: "active",
      id: "action",
      isSortable: false,
      isKey: true,
      render: (rowData) => {
        const { productcategoryid, active } = rowData;
        return (
          <div className="d-flex justify-content-start gap-x-1">
            <div
              style={{ marginRight: "10px" }}
              onClick={
                rowData.active
                  ? () => {
                      navigate(
                        `/admin/Categories?productcategoryid=${productcategoryid}`,
                        { state: { categoryname: rowData.category } }
                      );
                    }
                  : null
              }
            >
              <FontAwesomeIcon
                icon={faShareSquare}
                style={{
                  cursor: rowData.active ? "pointer" : "",
                  color: rowData.active ? "" : "#a4b9ce",
                }}
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id={`switch-${productcategoryid}`}
                defaultChecked={active}
                onChange={() => categoryActivate(rowData)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        );
      },
    },
  ];
};

const Users = () => {
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [createAgencyModal, setCreateAgencyModal] = useState(false);
  const navigate = useNavigate();

  const createCategory = useFormik({
    initialValues: {
      categoryName: "",
    },
    validationSchema: Yup.object().shape({
      categoryName: Yup.string().required("Category name cannot be empty."),
    }),
    onSubmit: async (values) => {
      setIsButtonClicked(true);
      const response = await createProductCategory(values);

      if (response) {
        toast.dismiss();
        toast.success("Category created successfully!");
        createCategory.resetForm();
        fetchUsers();
        setCreateAgencyModal(false);
      }
      setIsButtonClicked(false);
    },
  });

  const fetchUsers = async () => {
    try {
      // setIsLoading(true);
      const response = await getProductCategory();
      if (response && response.statuscode === 1) {
        setUsersData(response.data);
      } else {
        setError("Failed to fetch users data. Please try again later.");
      }
    } catch (error) {
      setError("Failed to fetch users data. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  async function categoryActivate(rowData) {
    const previousState = rowData.active;
    const updatedStatus = !previousState;
    rowData.active = updatedStatus;
    // console.log("rowData======>", rowData);
    try {
      const response = await toggleCategoryStatus(rowData.productcategoryid);
      if (response.statuscode === 1) {
        rowData.active = updatedStatus;
        toast.dismiss();
        toast.success(response.message);
        fetchUsers();
      } else {
        rowData.active = previousState;
        toast.dismiss();
        toast.error(response.message || "Failed to update category status.");
      }
    } catch (error) {
      rowData.active = previousState;
      toast.dismiss();
      toast.error("Failed to update category status. Please try again.");
    }
  }

  return (
    <div className="p-4 bg-white rounded-4 mt-5">
      <ToastContainer />
      <div className="d-flex justify-content-between w-100 align-items-center mb-4">
        <h3 style={{ color: "#262B40", fontWeight: "bold" }} className="mt-2">
          Category List
        </h3>
        <Row>
          <Col md={12} className="d-flex justify-content-end">
            <Button
              variant="primary"
              className="text-white bg-gradient"
              onClick={() => setCreateAgencyModal(true)}
            >
              CREATE CATEGORY
            </Button>
          </Col>
        </Row>
      </div>

      {/* {error && <div className="error-message">{error}</div>} */}
      <DynamicTable
        cols={cols(navigate, categoryActivate)}
        response={usersData}
        isPaginate={false}
        numberOfData={5}
        headerClass="table-header"
        rowHover={true}
        fixedHeight={false}
        isBgTransparent={false}
        hideHeader={false}
        isloading={isLoading}
      />

      <Modal
        show={createAgencyModal}
        onHide={() => {
          setCreateAgencyModal(false);
          createCategory.resetForm();
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Category</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={createCategory.handleSubmit}>
            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Category Name"
                  name="categoryName"
                  style={{ backgroundColor: "#F7F7F8" }}
                  value={createCategory.values.categoryName}
                  onChange={createCategory.handleChange}
                  onBlur={createCategory.handleBlur}
                  maxLength={30}
                  isInvalid={
                    createCategory.touched.categoryName &&
                    createCategory.errors.categoryName
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {createCategory.errors.categoryName}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                disabled={isButtonClicked}
                className="text-white bg-gradient"
                // onSubmit={createCategory.handleSubmit}
              >
                {isButtonClicked ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Users;
